<template>
<div class="patrolType">
   <el-drawer :title="drawerTitle" :size="drawerWidth" :modal="false" :visible.sync="drawerShow" @close="closeMess" :wrapperClosable="false" direction="rtl" ref="drawer">
      <patrol-type-drawer v-if="drawerShow" :editData="editData" :loading.sync="loading" :handleType="handleType" :templateId="templateId" :templateName="templateName" @confirm="handleConfirm" @cancel="handleCancel"></patrol-type-drawer>
   </el-drawer>
   <div class="mainContent" :style="styleObject">
      <div class="query">
         <span>
            <el-select v-model="params.likeKey" placeholder="请选择" clearable>
               <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-input v-model="params.likeValue" autocomplete="off" placeholder="请输入巡检类型名称"></el-input>
            <button class="primaryBtn" @click="loadTable" v-if="rolePermit('polling:type:query')">查询</button>
         </span>
         <button class="primaryBtn" @click="addClick" v-if="rolePermit('polling:type:add')">新增巡检类型</button>
      </div>
      <Tree-table :tableData="dataList" :pageSizes="[10, 20, 50]" :pages="pagination" :loading="tableLoading" :current-page="pagination.page" @currentChange="handleRoleCurrentChange" @sizeChange="handleRoleSizeChange">
         <el-table-column type="index" width="60" label="序号"></el-table-column>
         <el-table-column prop="name" label="巡检类型名称"></el-table-column>
         <el-table-column prop="" label="是否为设备类型">
            <template slot-scope="scope">
               <div>{{scope.row.isdevice==1?"是":"否"}}</div>
            </template>
         </el-table-column>
         <el-table-column prop="" label="操作" width="180" v-if="rolePermit('polling:type:edit')||rolePermit('polling:type:del')||rolePermit('polling:type:add')">
            <template slot-scope="scope">
              <el-button v-if="scope.row.tenantId&&scope.row.isdevice==0&&rolePermit('polling:type:add')" @click="addChildrenClick(scope.row)" size="small" class="detail">添加子项</el-button>
               <el-button v-if="rolePermit('polling:type:edit')" @click="editClick(scope.row)" size="small" class="edit">编辑</el-button>
               <el-button v-if="rolePermit('polling:type:del')" @click="delClick(scope.row)" size="small" class="del">删除</el-button>
            </template>
         </el-table-column>
      </Tree-table>
   </div>
</div>
</template>

<script>
import TreeTable from "@/components/common/TreeTable";
import PatrolTypeDrawer from "@/components/patrolManagement/PatrolTypeDrawer";

export default {
  components: {
    TreeTable,
    PatrolTypeDrawer
  },
  data() {
    return {
      params: {
        likeKey: "",
        likeValue: "",
        tenantId: "123456"
      },
      dataList: [],
      templateId: null, //选择行的类型ID
      templateName: "", //选择行的类型名
      styleObject: {
        height: ""
      },
      tableLoading: false,
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      drawerShow: false,
      handleType: "",
      drawerTitle: "",
      drawerWidth: "500px",
      editData:{},
      typeId:null,
      options:[
        {
          label:'父级巡检类型',
          value:'parent'
        },{
          label:'子级巡检类型',
          value:'children'
        }
      ]
    };
  },
  created() {
    this.makeheight()
  },
  mounted() {
    this.loadTable();
  },
  methods: {
    //查询
    loadTable() {
      let params = Object.assign({}, this.params);
      params.page = this.pagination.currentPage;
      params.pageSize = this.pagination.pageSize;
      this.dataList = [];
      this.request
        .post("/front/polling/type/getTypePageList", params)
        .then(res => {
          console.log(res);
          
          if (res.code == 200) {
            this.dataList = res.data.pageData;
            this.pagination.total = res.data.total;
          } else {
            this.pagination = {
              show: true,
              currentPage: 1,
              pageSize: 10,
              total: 0
            };
          }
        })
        .catch(error => console.log(error));
    },
    //表格当前页变化时
    handleRoleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.loadTable();
    },
    //表格展示条数变化时
    handleRoleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.loadTable();
    },
        //新增
    addClick(type) {
      this.drawerShow = true;
      this.drawerTitle = "新增巡检类型";
      this.handleType = "add";
      this.templateId = null;
      this.templateName = "";
      this.$store.commit("saveCurrDbSource", "新增巡检类型");
    },
    // 添加子项
    addChildrenClick(row){
      this.drawerShow = true;
      this.drawerTitle = "新增子巡检类型";
      this.handleType = "addChildren";
      this.templateId = row.id;
      this.templateName = "";
      this.$store.commit("saveCurrDbSource", "新增子巡检类型");
    },
    //编辑
    editClick(row) {
      console.log(row);
      this.typeId=row.id
      this.drawerShow = true;
      this.drawerTitle = "编辑巡检类型";
      this.handleType = "edit";
      // this.templateId = row.id;
      this.editData=row
      this.templateName = row.name;
      this.$store.commit("saveCurrDbSource", "编辑巡检类型");
    },
    //删除
    delClick(row) {
      this.$confirm("此操作将永久删除该巡检类型, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          this.request
            .delete("/front/polling/type/delete", {
              id: row.id
            })
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
                let num = ''
               if (this.pagination.total > 1) {
                  num = (this.pagination.total - 1) % this.pagination.pageSize
                  if (num == 0) {
                     if(this.pagination.currentPage>1){
                       this.pagination.currentPage = this.pagination.currentPage - 1
                     }
                  }
               }
                this.loadTable();
              } else if (res.code == 500) {
                this.msg.warn(res.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //关闭抽屉
    closeMess() {
      this.loading = false;
    },
    //确认
    handleConfirm(data) {
      //保存页面巡检类型信息
      if(this.handleType=='add'||this.handleType=="addChildren"){
        this.request
        .post("/front/polling/type/add",data)
        .then(res => {
          console.log(res);
          
          if (res.code == 200) {
            this.msg.success("添加成功");
          } else {
            this.msg.warn("添加失败，"+res.msg);
          }
          this.loadTable();
        })
        .catch(error => {
          console.log(error);
        });
      }else if(this.handleType=='edit'){
        Object.assign(data,{id:this.typeId})
        this.request
        .post("/front/polling/type/update",data)
        .then(res => {
          if (res.code == 200) {
            this.msg.success("修改成功");
          } else {
            this.msg.warn("修改失败");
          }
          this.loadTable();
        })
        .catch(error => {
          console.log(error);
        });
      }
      
      this.drawerShow = false;
    },
    //取消
    handleCancel(data) {
      console.log(data);
      this.drawerShow = false;
    },
     //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
  }
};
</script>

<style lang="scss" scoped>
.patrolType {
  .query {
    margin-bottom: 20px;
  }

  .topTabs {
    height: 40px;
    background: #fff;
  }

  .mainContent {
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;

    .edit {
      background: #327ae6;
      color: #fff;
    }
    .detail {
      background: #32AC63;
      color: #fff;
    }
    .del {
      background: #eaa13a;
      color: #fff;
    }
  }
}
</style><style lang="scss">
.patrolType {
  .query {
    .el-input {
      width:240px;
      margin-right: 10px;

      .el-input__inner {
        line-height: 36px;
        height: 36px;
      }
    }

    .el-select {
      width: 180px;
      margin-right: 10px;

      .el-input {
        width: 180px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }
    }

    .el-radio.is-checked .el-radio__input.is-checked .el-radio__inner {
      border-color: #42bced;
      background: #42bced;
    }

    .el-radio.is-checked .el-radio__label {
      color: #147dd9 !important;
    }
  }
}
</style>
